export enum TemplateVersionsEnum {
    VERSION_1 = "VERSION 1",
    VERSION_2 = "VERSION 2",
}
